"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _routerLink = _interopRequireDefault(require("./links/router-link"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["as", "children", "linkTo", "onClick"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "card__Wrapper",
  componentId: "sc-1g1tjuq-0"
})(["background-color:", ";border:1px solid ", ";border-radius:", "px;padding:12px;position:relative;text-decoration:none;transition:", ";transition-property:background-color,border-color;", " ", " ", " ", ""], (0, _styles.color)('white'), (0, _styles.color)('gray200'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('animations.fastTransition'), (0, _styledTools.ifProp)(function (_ref) {
  var onClick = _ref.onClick,
      to = _ref.to;
  return onClick || to;
}, (0, _styledComponents.css)(["appearance:none;color:inherit;cursor:pointer;text-decoration:inherit;&:active{background-color:", ";border-color:", ";}&:focus,&:hover{background-color:", ";outline:none;}"], (0, _styles.color)('blue100'), (0, _styles.color)('blue100'), (0, _styles.color)('gray200'))), (0, _styledTools.ifProp)('isSelected', (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.color)('blue100'))), (0, _styledTools.ifProp)('isClickable', (0, _styledComponents.css)(["&:focus,&:focus-within,&:hover{background-color:", ";}"], (0, _styles.color)('gray200'))), _styles.media.min('ms')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 16px;\n  "]))));
/**
 * `Card` component.
 */


function Card(props, ref) {
  var as = props.as,
      children = props.children,
      to = props.linkTo,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({}, rest, {
    as: to && _routerLink["default"] || onClick && 'button' || as,
    onClick: onClick,
    ref: ref,
    tabIndex: onClick ? 0 : undefined,
    to: to
  }), children);
}
/**
 * Forwarded `Card`.
 */


var ForwardedCard = /*#__PURE__*/(0, _react.forwardRef)(Card);
/**
 * Export `Card` component.
 */

exports.Card = ForwardedCard;